import { Popover } from 'antd';

import AntPopover from './styles/popover.style';

const CustomPopover = AntPopover(Popover);

export default CustomPopover;
